import React, { useState, useEffect, useRef } from "react";
import Dialog, { DialogHeader } from "../bootstrap/Dialog.jsx";
import DatagridFormComponent from "./DatagridFormComponent.jsx";
import LoadingIndicator from "../common/loading_indicator.jsx";

import { datagrid_get_component_props_json_path } from '~/routes';

const DatagridDialog = ({
  onClose,
  title,
  onSave,
  saveText,
  editable,
  datagridID,
  visibleCols,
  rowData,
  contextName = '',
  queryParams = {}
}) => {
  const [loading, setLoading] = useState(true);
  const [datagrid, setDatagrid] = useState({});
  const [context, setContext] = useState({});
  const datagridRef = useRef();

  useEffect(() => {

    if(datagridID) {
      jQuery.getJSON(datagrid_get_component_props_json_path({datagrid_id: datagridID, context_name: contextName, ...queryParams, _options: true}), (data) => {
        data.datagrid.columns = data.datagrid.columns?.filter(column => visibleCols.includes(column.id));
        data.context.permissions.presets_manage = false;
        setDatagrid(data.datagrid);
        setContext(data.context)
        setLoading(false)
      })
    }
  }, [datagridID]);

  const footer = editable && (
    <DialogFooter
      onSave={onSave}
      saveText={saveText}
      datagridRef={datagridRef}
    />
  );
  const header = <DialogHeader onClose={() => onClose(false)} title={title} />;
  return <Dialog footer={footer} header={header} size={'xl'}>
    {loading && <LoadingIndicator size='sm'/>}
      {Object.keys(datagrid).length > 0 && Object.keys(context).length > 0  &&
      (<DatagridFormComponent
        ref={datagridRef}
        datagrid={datagrid}
        context={context}
        editable={editable}
        supressToolbar={!editable}
        rowDataProps={rowData}
      />)}
    </Dialog>
};

const DialogFooter = ({onSave, saveText, datagridRef}) => (
    <div className="modal-footer">
        <div className="btn btn-primary" onClick={() => onSave(datagridRef.current.getRowData())}>{saveText}</div>
    </div>
)

export default DatagridDialog;
